<template>
  <div class="fixed-position homeHeader">
    <div :class="['head-bar', { headBarBorder: showLine }]">
      <!-- 顶部栏 -->
      <div class="head-top">
        <div class="top-container">
          <div class="top-left">
            <img
              src="../../assets/images/postion-v2.png"
              alt=""
              style="width: 14px; height: 14px"
            />
            <div style="position: relative">
              <el-select
                v-model="regionBar"
                @change="change_province"
                placeholder="请选择"
                ref="j-area-select"
                class="regionSelect areaSelect"
              >
                <el-option
                  v-for="item in regionBarOptions"
                  :key="item.value"
                  :label="item.label"
                  v-if="item.label != regionBar"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div class="select-change-btn" @click="openPicker">[切换]</div>
            </div>
            <!-- 费用说明 -->
            <template>
              <el-select
                value=""
                placeholder="找我婚礼费用说明"
                class="regionSelect fee-select"
                popper-class="fee-select-popper"
              >
                <el-option value="找我婚礼婚礼人其他费用说明">
                  <div class="fee-select-item">
                    <a
                      href="https://docs.qq.com/doc/DRUJ6WU1hU1FBU3NJ"
                      target="_blank"
                      >找我婚礼婚礼人其他费用说明</a
                    >
                    <i class="el-icon-arrow-right" />
                  </div>
                </el-option>
                <el-option value="找我婚礼费用结构说明">
                  <div class="fee-select-item">
                    <a
                      href="https://docs.qq.com/sheet/DRURyTEluUlpheU9v"
                      target="_blank"
                      >找我婚礼费用结构说明</a
                    >
                    <i class="el-icon-arrow-right" />
                  </div>
                </el-option>
                <el-option value="找我婚礼布置费人员价格指导">
                  <div class="fee-select-item">
                    <a
                      href="https://docs.qq.com/sheet/DRVpJWU1qWW1KaG54"
                      target="_blank"
                      >找我婚礼布置费人员价格指导</a
                    >
                    <i class="el-icon-arrow-right" />
                  </div>
                </el-option>
                <el-option value="找我婚礼退单标准说明">
                  <div class="fee-select-item">
                    <a
                      href="https://docs.qq.com/sheet/DRWFXbXFqZHByRUZh"
                      target="_blank"
                      >找我婚礼退单标准说明</a
                    >
                    <i class="el-icon-arrow-right" />
                  </div>
                </el-option>
              </el-select>
            </template>
          </div>
          <div class="top-right">
            <!-- <div class="app-code-section flex-row">
              <img src="../../assets/imgs/phone.png" width="11" alt="phone" class="phone-icon" />

              <div class="down-app-text">下载APP</div>
              <div class="app-sub-content">
                <img src="../../assets/imgs/logo-img.png" width="54" alt="logo" />
                <p class="app-main-title">找我婚礼APP</p>
                <p class="app-sub-title">让每一场婚礼都超越期待</p>
                <img src="https://img.izhaowo.com/pc-wap/image/down-app.png" width="92" alt="code" />
              </div>
              
            </div> -->
            <!-- 登录 -->

            <!-- <div class="f-login">
              <div class="f-login-c" v-if="!isLogin">
                <a id="tj-header-login" href="/login" class="cup" style="margin: 0 10px;" rel="nofollow">登录</a>
              </div>
              <div class="f-login-c" v-else>
                <a :href="userUrl + '/collect/team.html'" target="_blank">
                  <img v-if="imgsrc" :src="imgsrc | imgcrop(30, 30)" />
                  <img src="../../assets/images/default-peo.png" v-else />
                  <span class="user-name">{{ userName }}</span>
                </a>
                <a class="cup" @click="clearCookie">退出</a>
              </div>
            </div> -->

            <!-- 招募合伙人 -->
            <!-- <a
              :href="newUrl + '/cityPartner'"
              tag="a"
              class="go-partner"
              target="_blank"
              >招募城市合伙人</a
            > -->
            <a href="https://w.izhaowo.com" class="go-worker" target="_blank"
              >婚礼人入驻</a
            >
          </div>
        </div>
      </div>
      <!-- 顶部菜单栏 -->
      <div class="wrapper">
        <div class="flex-row page-width-header" style="align-items: center">
          <a :href="newUrl" tag="div" class="logo"></a>
          <div class="menu-item" :class="{ selected: false }">
            <a :href="newUrl" class="link menu-item-inner" tag="a">首页</a>
          </div>
          <!-- <div class="menu-item">
            <a
              target="_blank"
              :class="['link', 'menu-item-inner', { selected: false }]"
              rel="nofollow"
              href="https://echoey.izhaowo.com/"
              >ECHOEY案例</a
            >
          </div> -->
          <div class="menu-item">
            <a
              target="_blank"
              :class="['link', 'menu-item-inner', { selected: false }]"
              rel="nofollow"
              href="https://1thlook.com/"
              >萬拾艺术中心</a
            >
          </div>
          <!-- @mouseenter="menuMouseEnter(menu)" @mouseleave="menuMouseLeave(menu)" -->
          <div
            class="menu-item"
            v-for="menu in menuList"
            :class="{
              selected: menu.selected,
              teamMenu: menu.name === '婚礼团队',
            }"
            :key="menu.name"
          >
            <!-- :target=" menu.path == '/case' ? '_blank' : ''" -->
            <a
              :href="newUrl + menu.path"
              tag="a"
              class="link menu-item-inner"
              >{{ menu.name }}</a
            >
            <div class="menu-second" v-show="menu.name === '婚礼团队'">
              <a :href="newUrl + '/worker/b0'">策划师</a>
              <a :href="newUrl + '/worker/b1'" to="/worker/b1">化妆师</a>
              <a :href="newUrl + '/worker/b2'" to="/worker/b2">主持人</a>
              <a :href="newUrl + '/worker/b3'" to="/worker/b3">摄影师</a>
              <a :href="newUrl + '/worker/b4'" to="/worker/b4">摄像师</a>
              <a :href="newUrl + '/planner'" to="/planner">统筹师</a>
            </div>
            <div class="menu-second" v-show="menu.name === '找我案例'">
              <a :href="newUrl + '/case'" to="/case">找我案例</a>
              <a :href="newUrl + '/explosionCase'" to="/explosionCase"
                >爆款案例</a
              >
              <a :href="newUrl + '/goodCase'" to="/goodCase">专家好评榜</a>
            </div>
            <div class="menu-second" v-show="menu.name === '找我故事'">
              <a :href="newUrl + '/ourStory/primacy'">找我初心</a>
              <a :href="newUrl + '/ourStory/culture'">找我文化</a>
              <a :href="newUrl + '/ourStory/service'">服务内容</a>
              <a :href="newUrl + '/ourStory/progress'">找我历程</a>
            </div>

            <!-- <div class="header-team-content" v-show="menu.name === '婚礼团队'">
              <div class="team-content-inner">
                <WeddingTeamNav></WeddingTeamNav>
              </div>
            </div> -->

            <div class="menu-second"></div>
          </div>
          <!-- <div class="menu-item">
            <a class="menuLink menu-item-inner" rel="nofollow" :href="newUrl" target="_blank">快速定制</a>
          </div> -->
          <!-- <i style="flex-grow: 1;"></i> -->
          <!-- 搜索 -->
          <div :class="['search-box', { 'big-search-box': largeBox }]">
            <!-- 以图搜图模块 -->
            <div class="pic-to-pic-content unblur-1" @click.stop="boxClick">
              <img
                class="unblur-2"
                title="以图搜图"
                @click.stop="picSearchChange"
                src="https://img.izhaowo.com/pc-wap/image/pic-search-btn-img.png"
                alt=""
              />
              <div class="unblur-3" @click.stop="searchHeader">搜索</div>
            </div>
            <!-- 图片上传 -->
            <div
              @click.stop="() => {}"
              class="upload-content"
              v-show="isPicToPic"
            >
              <div class="upload-content-inner">
                <img
                  class="upload-content-inner-img"
                  src="https://img.izhaowo.com/pc-wap/image/pic-search-img-upload-icon.png"
                  alt=""
                />
                <div class="upload-content-inner-text">
                  <span>将参考图拖拽至此，或</span>
                  <span>点击上传</span>
                </div>
              </div>
              <div class="upload-box">
                <UploadImage
                  :uploadInfo="avatarUploadInfo"
                  ref="UploadAudios"
                  :refName="'headUpload'"
                  v-loading="isUploading"
                  @uploading="uploading"
                  @uploadFailed="uploadFailed"
                  @uploaded="musicUploaded"
                  :autoUpload="false"
                  :isMutli="true"
                  :maxSize="5"
                  acceptType=".png,.jpg,.jpeg"
                  :limitSize="10"
                >
                </UploadImage>
              </div>
            </div>
            <!--  -->

            <el-input
              :placeholder="isPicToPic ? '正在以图搜图' : '请输入关键词'"
              size="mini"
              @focus="inputFocus"
              @blur="inputBlur"
              :readonly="isPicToPic"
              v-model="searchBarText"
              @keyup.native.enter="searchHeader"
              :class="[
                'search-input-select',
                'common-input',
                {
                  'big-search': largeBox,
                },
              ]"
            >
              <el-select
                v-model="searchBar"
                placeholder="请选择"
                slot="prepend"
                class="inner-person-select"
                size="mini"
              >
                <el-option
                  v-for="item in searchBarOptions"
                  :key="item.value"
                  :label="item.label"
                  v-show="item.value != searchBar"
                  :value="item.value"
                ></el-option>
              </el-select>
              <!-- <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchHeader"
                style="background-color: #50D3DA;"
              ></el-button> -->
              <i
                slot="suffix"
                v-if="!largeBox"
                class="el-input__icon index-search-icon el-icon-search"
                @click="searchHeader"
              ></i>
            </el-input>
          </div>
          <!-- 用户头像 -->
          <div class="user-content" v-if="!largeBox">
            <a
              :href="newUrl + '/login'"
              class="without-user-img"
              v-if="!isLogin"
            >
              <img :src="userNoneImg" alt="" />
            </a>
            <el-popover
              v-else
              placement="bottom"
              width="88"
              popper-class="login-popper"
              trigger="click"
            >
              <div class="user-picker-content">
                <span @click="toUserCenter">个人中心</span>
                <span @click="clearCookie">退出登录</span>
              </div>
              <img
                slot="reference"
                v-if="imgsrc"
                :src="imgsrc | imgcrop(32, 32, '', false)"
                class="header-user-img"
                alt=""
              />
              <img
                slot="reference"
                v-else
                src="../../assets/images/default-peo.png"
              />
            </el-popover>
          </div>
          <!--  -->
          <!-- <div class="app-code-section flex-row">
            <div class="down-btn-content">
              <div class="down-app-text">下载APP</div>
              <img
                src="../../assets/images/phone-v2.png"
                width="11"
                alt="phone"
                class="phone-icon"
              />
            </div>

            <div class="app-sub-content">
              <p class="app-main-title">下载找我婚礼</p>
              <p class="app-sub-title">随时随地查看更多案例</p>
              <img
                class="app-download-link"
                src="https://img.izhaowo.com/pc-wap/image/down-app.png"
                width="92"
                alt="code"
              />
              <div class="app-sub-bottom">
                <img src="../../assets/images/phone-gray.png" alt="" />
                <span>手机扫码下载</span>
              </div>
            </div>
          </div> -->
        </div>
        <slot></slot>
      </div>
    </div>
    <!--  -->
    <!--  -->
  </div>
</template>

<script>
import UploadImage from "./upload-image.vue";
import $ from "n-zepto";
import CookieUtil from "@/plugin/cookie.js";
import api from "@/config/api.js";
import userNoneImg from "../../assets/images/user-icon.png";
import tools from "../../plugin/tools/tools.js";
export default {
  name: "base-barner",
  components: { UploadImage },
  data() {
    return {
      largeBox: false,
      userNoneImg: userNoneImg,
      showLine: false,
      userUrl: "https://my.izhaowo.com",
      newUrl: api.WWW_IZHAOWO_URL,
      headerLogo: false,
      // 页面是否刷新
      relouded: false,
      isIndex: false,
      menuList: [
        { selected: false, name: "找我案例", path: "/case" },
        { selected: false, name: "婚礼团队", path: "/worker/b0" },
        { selected: false, name: "婚宴酒店", path: "/hotel" },
        { selected: false, name: "找我故事", path: "/ourStory/primacy" },
        // { selected: false, name: '服务介绍', path: '/goods' }
      ],
      searchBar: "婚礼人",
      searchBarOptions: [
        {
          value: "婚礼人",
          label: "婚礼人",
        },
        {
          value: "酒店",
          label: "酒店",
        },
        {
          value: "案例",
          label: "案例",
        },
      ],
      regionBar: "",
      regionBarOptions: [],
      searchBarText: "",
      isLogin: "",
      imgsrc: "",
      userName: "",
      provinceUrl: "",
      avatarUploadInfo: {},
      isPicToPic: false, //以图搜图中
      imgUrl: "",
      isUploading: false,
    };
  },
  created() {
    // this.getUploadInfo();

    this.isLogin = CookieUtil.get("usr-token") ? true : false;
    this.imgsrc = CookieUtil.get("usr-avator")
      ? CookieUtil.get("usr-avator")
      : "";
    this.userName = CookieUtil.get("usr-name")
      ? CookieUtil.get("usr-name")
      : "";
    this.init();
  },

  methods: {
    mDown() {
      this.isMousedown = true;
      console.log("-----左键按下");
    },
    mUp() {
      this.isMousedown = false;
      console.log("-----左键抬起");
    },
    boxClick() {
      console.log("--------boxClick");
      this.isBoxClick = true;
    },
    inputFocus() {
      console.log("-----------inputFocus---获取焦点");
      if (this.searchBar == "案例") {
        setTimeout(() => {
          this.largeBox = true;
        }, 100);
      }
    },
    inputBlur() {
      console.log("-----------inputBlur---失去焦点");
      setTimeout(() => {
        if (this.isMousedown) {
          console.log("-----------inputBlur---失去焦点---0");
          return;
        }
        if (this.isBoxClick) {
          this.isBoxClick = false;
          console.log("-----------inputBlur---失去焦点---1");
          return;
        }
        if (this.isPicToPic) {
          console.log("-----------inputBlur---失去焦点---1");
          return;
        }
        console.log("-----------inputBlur---失去焦点---3");
        this.largeBox = false;
      }, 100);
    },
    loadChange(val) {
      this.$emit("loadChange", val);
    },
    picSearchChange() {
      if (this.isPicToPic) {
        this.isPicToPic = false;
        console.log("-----------picSearchChange---点击相机---1");
        this.largeBox = false;
        this.searchBarText = this.searchBarTextCopy || "";
        return;
      }
      this.isPicToPic = true;
      console.log("-----------picSearchChange---点击相机---2");
      this.searchBarTextCopy = this.searchBarText;
      this.searchBarText = "";
      let bodyEle = document.getElementsByTagName("body")[0];
      if (this.bodyBindOver) {
        return;
      }
      console.log("试试");
      bodyEle.onclick = () => {
        console.log("-------aaaa", "退出以图搜图");
        if (this.isPicToPic) {
          console.log("-------aaaa", "退出以图搜图--------1");
          this.searchBarText = this.searchBarTextCopy || "";
          this.isPicToPic = false;
          // this.largeBox = false
        }
      };
      this.bodyBindOver = true;
      console.log("bodyEle", bodyEle);
    },

    uploadFailed() {
      this.uploadingData = [];
      this.loadChange(false);
      this.$message({
        customClass: "music-message",
        type: "error",
        message: "上传失败，请稍后重试",
      });
    },
    uploading(params) {
      console.log("----------params", params);
      this.isUploading = true;
      let obj = {
        id: -1,
        url: "",
        firstName: params.file.name.split(".")[0],
        suffixName: params.file.name.split(".")[1],
      };
      this.uploadingData = [];
      this.uploadingData.push(obj);
      console.log("------可以上传", params);
      // this.$store.commit('topSearchImgChange', params.url);
      // this.$store.commit('imgSearchCountChange', this.imgSearchCount + 1);
      let imgSearchCount = sessionStorage.getItem("imgSearchCount") - 0 || 0;
      imgSearchCount = imgSearchCount + 1;
      sessionStorage.setItem("imgSearchCount", imgSearchCount);
      this.loadChange(true);
      console.log("-----上传开始---计数", imgSearchCount);

      //开始loading

      setTimeout(() => {
        this.isPicToPic = false;
        this.largeBox = false;
        this.searchBarText = this.searchBarTextCopy || "";
      }, 100);
    },
    musicUploaded(params) {
      let imgSearchCount = sessionStorage.getItem("imgSearchCount") - 0 || 0;
      console.log("上传成功！", params, this.$route);
      console.log(
        "-----上传结束---计数",
        params.imgSearchCount,
        "最新计数",
        imgSearchCount
      );
      if (imgSearchCount > params.imgSearchCount) {
        console.log("----上传作废");
        return;
      }

      // params.url---跳转主站搜索
      console.log("----params.url---跳转主站搜索", params.url);
      this.loadChange(false);
      window.open(`https://www.izhaowo.com/search?s=&searchImg=${params.url}`);

      // this.$store.commit('topSearchImgChange', params.url);
      // // window.location.href = window.location.origin + '/search' + '?' + 's=' + this.searchBarText + '&'
      // //   + 'searchImg=' + params.url
      // this.$router.push({path: '/search', query: {s: this.searchBarText, searchImg: params.url}})
    },
    async getUploadInfo() {
      // const data = await oss.getOssImgUploadSign()
      // this.avatarUploadInfo = data
      let url = api.topURL + "/app-api/tool/v1/get/oss/upload/sign";
      console.log("--------url", url);
      let vm = this;
      $.ajax({
        type: "get", //请求方式
        url: url,
        // jsonp: "callbackparam",
        // dataType: "json",
        contentType: "application/json;utf-8",
        crossDomain: true,
        data: {},
        success: function (result) {
          console.log("------------result", result);
          if (!result) {
            console.log("----请求错误");
            return;
          }
          switch (result.rcode) {
            case "000000":
              const res = result.rdata;
              vm.avatarUploadInfo = {
                OSSAccessKeyId: res.accessid,
                policy: res.policy,
                Signature: res.signature,
                dir: res.dir,
                key: `${res.dir}${tools.getUUID()}`,
                host: res.host,
              };
              break;
            case "800001":
              break;
            default:
              console.log("----请求错误");
              break;
          }
          return;
        },
        error: (err) => {
          console.log("-----err", err);
        },
      });
    },

    toUserCenter() {
      window.open(`${this.userUrl}/collect/team.html`);
    },
    getScroll() {
      if (window.scrollY != 0) {
        this.showLine = true;
      } else {
        this.showLine = false;
      }
    },
    openPicker() {
      console.log("ref", this.$refs);
      this.$refs["j-area-select"].focus();
    },
    async init() {
      await this.queryProvince();
      console.log(CookieUtil.get("PROVINCE_NAME"));
      this.regionBar = CookieUtil.get("PROVINCE_NAME") || "";
      // let list = CookieUtil.get('PROVINCE_LIST')
      // if(list == 'undefined' || !list || list.length <= 0){
      //   console.log('test')
      //   await this.queryProvince()
      // }else{
      //   let data = list.split(",")
      //   this.$set(this,'regionBarOptions',list)
      // }
    },
    async queryProvince() {
      let result = [];
      let list = [];
      let url = api.TOP_URL + "app-api/province/v1/query/list";
      let all_city = [];
      let vm = this;
      vm.getAjax(
        url,
        "",
        function (recomData) {
          if (recomData && recomData.rcode === "000000") {
            result = recomData.rdata;
            for (let i in result) {
              let item = {};
              item.value = result[i].province;
              item.label = result[i].province;
              item.province_id = result[i].provinceId;
              item.provincialCapitalEn = "/" + result[i].provincialCapitalEn;
              item.index = parseInt(i) + 1;
              item.citys = result[i].citys;
              if (
                result[i].province === "重庆市" ||
                result[i].province === "天津市" ||
                result[i].province === "上海市" ||
                result[i].province === "北京市"
              ) {
                item.citys.push({
                  name: result[i].province,
                });
              }
              list.push(item);
              //全国显示所有城市
              all_city.push(...result[i].citys);
            }
            //省份中没有返回全国字段 需要自己拼接
            list.unshift({
              value: "",
              label: "全国",
              province_id: "",
              index: 0,
              provincialCapitalEn: "/",
              citys: all_city,
              province: "全国",
            });
            if (result && result.length > 0) {
              //设置省份配置地址
              CookieUtil.set("PROVINCE_LIST", list);
              vm.$set(vm, "regionBarOptions", list);
            }
          }
        },
        function () {}
      );
    },
    /**
     * 退出登录
     */
    clearCookie: function () {
      //清楚cookie
      CookieUtil.delete("usr-token");
      CookieUtil.delete("usr-token", { domain: ".izhaowo.com" });
      CookieUtil.delete("usr-name");
      CookieUtil.delete("usr-name", { domain: ".izhaowo.com" });
      CookieUtil.delete("usr-avator");
      CookieUtil.delete("usr-avator", { domain: ".izhaowo.com" });
      CookieUtil.delete("usr-id");
      CookieUtil.delete("usr-id", { domain: ".izhaowo.com" });
      CookieUtil.delete("wed-info");
      CookieUtil.delete("wed-date");
      window.location.reload(true);
      return;
    },

    /**
     * 头部搜索
     */
    searchHeader() {
      if (this.isPicToPic) {
        return;
      }
      if (this.searchBar === "婚礼人") {
        window.location.href = this.newUrl + `/worker?s=${this.searchBarText}`;
      } else if (this.searchBar === "酒店") {
        window.location.href = this.newUrl + `/hotel?s=${this.searchBarText}`;
      } else if (this.searchBar === "案例") {
        window.location.href = this.newUrl + `/case?s=${this.searchBarText}`;
      } else if (this.searchBar === "攻略") {
        window.location.href =
          this.newUrl + `/strategy?s=${this.searchBarText}`;
      }
    },

    // 改变省份时触发
    change_province(value) {
      for (let [index, item] of this.regionBarOptions.entries()) {
        if (item.value === value) {
          CookieUtil.set("PROVINCE_ID", item.province_id);
          CookieUtil.set("PROVINCE_INDEX", item.index);
          CookieUtil.set("PROVINCE_NAME", item.value);
        }
      }
    },
  },

  mounted() {
    let bodyEle = document.getElementsByTagName("body")[0];
    bodyEle.onmousedown = (e) => {
      this.storageEle = e.target;
      this.mDown();
    };
    bodyEle.onmouseup = (e) => {
      console.log(
        "----e",
        this.storageEle.className,
        e.target == this.storageEle
      );
      this.mUp();
      if (
        e.target != this.storageEle &&
        this.storageEle.className != "el-input__inner"
      ) {
        this.inputBlur();
      }
      if (
        e.target == this.storageEle &&
        this.storageEle.className != "el-input__inner" &&
        this.storageEle.className != "pic-to-pic-content unblur-1" &&
        this.storageEle.className != "unblur-2" &&
        this.storageEle.className != "unblur-3"
      ) {
        this.inputBlur();
      }
    };

    this.isLogin = !!CookieUtil.get("usr-token");
    this.imgsrc = CookieUtil.get("usr-avator")
      ? CookieUtil.get("usr-avator")
      : "";
    window.addEventListener("scroll", this.getScroll);
  },
};
</script>

<style>
.login-popper {
  padding: 0;
  background: #fff;
  border-radius: 8px;
  min-width: 80px;
  box-shadow: 0 0 24px 0 rgb(0 0 0 / 20%);
}
</style>
<style scoped>
.fixed-position {
  position: relative;
  min-height: 120px;
}
.head-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  min-width: 1224px;
  width: 100%;
  font-size: 14px !important;
  min-height: 120px;
  background: #ffffff;
  border-bottom: 1px solid #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.headBarBorder {
  border-bottom: 1px solid #f3f3f3;
}
.head-bar .wrapper {
  min-height: 84px;
}
.head-bar .logo {
  margin-right: 102px;
  width: 128px;
  height: 44px;
  background: url(https://img.izhaowo.com/pc-wap/image/logo-v2.png) 0 0
    no-repeat;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
}
.indexHeader .logo {
  background: url("../../assets/images/ico-logo-fff.png") 0 0 no-repeat;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
}
.head-bar .icon-logo {
  width: 112px;
}
.head-bar .menu-item {
}
.head-bar .menu-item > a {
  cursor: pointer !important;
  /* margin: 0 20px; */
  margin: 0 16px;
  font-size: 14px;
  color: #828b9b;
  font-weight: 400;
  line-height: 50px !important;
  height: 50px;
  display: block;
}
.menuLink {
  font-size: 16px;
  color: #000000;
  line-height: 50px;
  height: 50px;
  margin-left: 20px;
}
.menuLink::hover {
  font-weight: 500;
  border-bottom: 2px solid #262626;
  color: #262626;
}
.menu-item.selected .link {
  color: #262626;
  border-bottom: 2px solid #b39479 !important;
  font-weight: 600;
}
/* .menu-item:hover .link {
  border-bottom: 2px solid #262626;
  color: #262626;
} */

.menu-item .menu-item-inner::after {
  content: "";
  display: block;
  width: 0px;
  transition: 0.6s;
  height: 2px;
  /* background: rgba(0, 0, 0, 0.9); */
  position: relative;
  top: -2px;
}

.menu-item:hover .menu-item-inner::after {
  content: "";
  display: block;
  width: 100%;
  transition: 0.6s;
  height: 2px;
  background: #b39479;
  position: relative;
  top: -2px;
}
.menu-item:hover .menu-item-inner {
  color: #262626;
  font-weight: 600;
}

/* .indexHeader .head-bar .button-search {
  background: url('../../assets/imgs/ico-fffSearch.png') center center no-repeat;
} */
/* .head-bar .button-search {
  background: url('../../assets/imgs/ico-graySearch1.png') center center no-repeat;
  width: 20px;
  height: 20px;
  background-size: 20px 20px;
  display: inline-block;
} */
/* .head-bar .button-search img {
  width: 20px;
  height: 20px;
} */
/* 搜索框 */
/* #searchBox {
  width: 0;
  height: 40px;
  overflow: hidden;
} */

/* .searchCloseImg {
  width: 30px;
  height: 40px;
  background: url(../../assets/imgs/ico-graySearch.png) center center no-repeat;
} */
/* #searchBox .searchBarText {
  width: 130px;
  height: 40px;
  color: #666;
  border: none;
} */
/* .closeSearch {
  display: inline-block;
  width: 30px;
  height: 40px;
  background: url(../../assets/imgs/ico-closeBtn.png) center center no-repeat;
  -webkit-background-size: 50% auto;
  background-size: 50% auto; */
/*padding-top: 5px;*/
/* } */
/* #searchBox .searchCloseImg,
#searchBox img,
#searchBox .searchBarSelect,
#searchBox .searchBarText,
#searchBox .closeSearch {
  float: left;
} */
.login {
  margin-left: 20px;
}
.login {
  /*font-weight: 600;*/
}
</style>

<style>
.regionSelect input[type="text"] {
  padding-left: 9px;
}
/* 区域选择 */
.regionSelect {
  width: 80px;
  border: none;
}
.regionSelect.fee-select {
  margin-left: 20px;
  width: 140px;
}
.fee-select-popper {
  width: 256px;
}
.fee-select-popper .fee-select-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  color: #464646;
}
.fee-select-item a {
  font-size: 12px !important;
}
.fee-select .el-input__inner::placeholder {
  color: #333;
}
.regionSelect .el-input__inner {
  border: none !important;
  background: none;
  font-size: 12px !important;
}
/* .searchBarSelect {
  margin-right: 16px;
  color: #666;
} */
.searchBarSelect .el-input__inner {
  /* border: none !important; */
  /* width: 92px; */
}
.searchBarSelect .el-icon-arrow-up:before,
.regionSelect .el-icon-arrow-up:before {
  content: "\e6e1";
  color: #666;
}

/* header 透明 */
.indexHeader {
  position: fixed !important;
  z-index: 999;
}
.indexHeader .head-bar {
  background-color: rgba(0, 0, 0, 0);
  background-image: linear-gradient(
    -180deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}
.indexHeader .head-bar a {
  color: #fff !important;
}
.indexHeader .el-input__inner {
  color: #fff !important;
}
.indexHeader input {
  background: none;
  color: #fff !important;
}
.indexHeader input::-webkit-input-placeholder {
  color: #fff;
}
.indexHeader input:-moz-placeholder {
  color: #fff;
}
.indexHeader input::-moz-placeholder {
  color: #fff;
}
.indexHeader input:-ms-input-placeholder {
  color: #fff;
}
.indexHeader .searchBarSelect .el-icon-arrow-up:before,
.indexHeader .regionSelect .el-icon-arrow-up:before {
  color: #fff;
}
.indexHeader .login {
  color: #fff;
}
.search-box .el-select .el-input {
  width: 83px !important;
}
.search-box {
  width: 200px;
  margin-left: 24px;
  transition: 0.3s;
}
.search-input-select {
  border-radius: 15px;
  overflow: hidden;
  border: 1px solid #efefef;
}
.search-input-select .el-input-group__prepend {
  background-color: #fff !important;
  /* border-right: 0 !important;
  border-color: #f1f1f1 !important; */
  border: none !important;
}
.search-input-select input[type="text"] {
  /* border-top-color: #f1f1f1 !important;
  border-bottom-color: #f1f1f1 !important;
  border-left: 0 !important;
  border-right-color: #f1f1f1 !important; */
  /* border-right: 0 !important; */
  /* border-radius: 15px; */
  border: none !important;
}
/* .search-input-select . {
  background-color: #a28b77 !important;
  border-radius: 0 4px 4px 0 !important;
} */
.search-input-select .el-input-group__append .el-icon-search {
  color: #fff !important;
  font-size: 18px !important;
}
/* / header 透明 */
</style>

<style scoped>
.head-bar .head-top {
  width: 100%;
  height: 44px;
  background: #f7f7f7;
}

.head-bar .head-top .top-container {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: 1224px;
  height: 40px;
  align-items: center;
}

.head-bar .head-top .top-container .top-left {
  display: flex;
  align-items: center;
}

.head-bar .head-top .top-container .top-right {
  display: flex;
  align-items: center;
}

.menu-item {
  position: relative;
}

.menu-item .menu-second {
  display: none;
  width: 100%;
  position: absolute;
  top: 50px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  border-radius: 2px;
}

.menu-item .menu-second a {
  display: block !important;
  height: 40px;
  line-height: 40px !important;
  width: 100%;
  border-bottom: 0;
  text-align: center !important;
}

.menu-item .menu-second .nuxt-link-active {
  color: #b39479;
}

.menu-item .menu-second a:hover {
  color: #b39479;
}

.menu-item:hover .menu-second {
  display: block;
}

.indexHeader .menu-item {
  position: relative;
}

.indexHeader .menu-item .menu-second {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 2px;
}

.indexHeader .menu-item .menu-second a:hover {
  color: #262626 !important;
}

.app-code-section {
  box-sizing: border-box;
  position: relative;
  align-items: center;
  width: 96px;
  height: 32px;
  background: rgba(87, 210, 205, 0.06);
  border: 1px solid #b39479;
  border-radius: 16px;
  margin-left: 12px;
  justify-content: center;
  cursor: pointer;
}

.app-code-section img.phone-icon {
  vertical-align: middle;
  font-size: 0;
  height: 16px;
  width: 16px;
}

.app-code-section .down-btn-content {
  display: flex;
  width: 64px;
  height: 17px;
}

.app-code-section .down-app-text {
  font-weight: 400;
  color: #a28b77;
  line-height: 17px;
  font-size: 12px !important;
  font-weight: 400 !important;
}

.app-code-section:hover .app-sub-content {
  display: block;
}

.app-code-section .app-sub-content {
  display: none;
  position: absolute;
  left: -50px;
  top: 42px;
  z-index: 999;
  padding: 28px 0 60px 0;
  width: 250px;
  background: #fff;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  text-align: center;
  box-sizing: border-box;
  color: #333;
}

.app-code-section .app-sub-content .app-main-title {
  font-size: 18px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.9);
  line-height: 25px;
  margin-bottom: 14px;
}

.app-code-section .app-sub-content .app-sub-title {
  font-size: 16px;
  font-weight: 300;
  font-family: PingFangSC-Light;
  color: rgba(0, 0, 0, 0.9);
  line-height: 22px;
  margin-bottom: 27px;
}

.app-code-section .app-sub-content .app-download-link {
  display: block;
  width: 156px;
  height: 156px;
  margin: 0 auto;
}

.app-code-section .app-sub-content .app-sub-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.app-code-section .app-sub-content .app-sub-bottom img {
  width: 15px;
  height: 15px;
}

.app-code-section .app-sub-content .app-sub-bottom span {
  font-size: 16px;
  font-weight: 300;
  font-family: PingFangSC-Light;
  color: rgba(0, 0, 0, 0.9);
  line-height: 22px;
}

.f-login .f-login-c {
  display: flex;
  align-items: center;
  color: #464646;
  font-size: 12px;
}

.f-login .f-login-c a {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 12px;
}

.f-login img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  vertical-align: baseline;
}

.f-login .user-name {
  margin: 0 10px;
  font-size: 12px;
}

.go-partner,
.go-worker {
  margin-left: 40px;
  font-size: 12px;
}

.page-width-header {
  position: relative;
  width: 1224px;
  min-height: 84px;
}

/deep/ .areaSelect .el-input__suffix {
  visibility: hidden;
}

/deep/ .areaSelect .el-input__inner {
  color: #78787c;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}

/deep/ .fee-select .el-input__inner::-webkit-input-placeholder {
  color: #78787c;
}

/deep/ .search-input-select .el-input-group__prepend {
  padding-right: 0px;
}

/deep/ .inner-person-select .el-input--suffix {
  color: #262626;
  font-size: 12px;
}

/deep/ .inner-person-select .el-input .el-input__suffix {
  right: 15px;
}

.area-switch-btn {
  color: #78787c;
}

.search-input-select {
  padding-top: 1px;
  padding-bottom: 1px;
}

.search-input-select /deep/ .el-input__inner {
  padding-left: 11px;
}

.search-input-select /deep/ .el-input__suffix {
  background-image: url("../../assets/images/search-icon-search.png");
  background-size: cover;
  width: 20px;
  height: 20px;
  top: 5px;
  right: 14px;
  cursor: pointer;
}

.search-input-select /deep/ .el-input__suffix .el-input__suffix-inner {
  opacity: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.search-input-select /deep/ .el-input-group__prepend {
  transform: translateY(-1px);
}

.search-input-select /deep/ .el-input-group__prepend .el-input__inner {
  padding-left: 12px;
  width: 36px;
  box-sizing: content-box;
  padding-right: 8px;
}

.search-input-select
  /deep/
  .el-input-group__prepend
  .el-input
  .el-input__suffix {
  top: unset;
  margin-top: 5px;
  right: 27px;
  background-image: url("../../assets/images/search-icon-down.png");
  background-size: cover;
  width: 6px;
  height: 18px;
}

.search-input-select
  /deep/
  .el-input-group__prepend
  .el-input
  .el-input__suffix
  .el-input__suffix-inner {
  display: none;
}

.search-input-select
  /deep/
  .el-input-group__prepend
  .el-input.is-focus
  .el-input__suffix {
  margin-top: 7px;
  transform: rotate(180deg);
  transition: 0.5s;
}

.top-right a {
  color: #78787c;
}

.index-search-icon {
  position: relative;
  top: 2px;
}

.select-change-btn {
  position: absolute;
  width: 38px;
  background: #f7f7f7;
  left: 43px;
  top: 12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #78787c;
  line-height: 17px;
  pointer-events: none;
  cursor: pointer;
  text-align: right;
}

.user-content {
  margin-left: 12px;
  width: 32px;
  height: 32px;
}

.user-content .without-user-img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  cursor: pointer;
}

.user-content .without-user-img img {
  display: block;
  width: 100%;
}

.user-content .header-user-img {
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
}

.user-picker-content {
  padding: 12px 0;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.user-picker-content span {
  display: block;
  font-size: 12px;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
}

.user-picker-content span:hover {
  background: #f5f5f7;
}

.header-team-content {
  position: fixed;
  top: 125px;
  width: 100%;
  height: 443px;
  overflow: hidden;
  background: #fff;
  z-index: 999;
  box-shadow: 0px 0px 10px -2px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(32px);
}

.team-content-inner {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.search-box {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 152px;
}

.user-content {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 108px;
}

.app-code-section {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
}

/*  */
.search-box {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 44px;
}

.search-box .pic-to-pic-content {
  display: none;
}

.big-search-box {
  width: 244px;
  right: 0px;
}

.big-search-box .pic-to-pic-content {
  display: flex;
}

.pic-to-pic-content {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  right: 0;
  top: 0;
  height: 100%;
  user-select: none;
}

.pic-to-pic-content img {
  display: block;
  width: 18px;
  height: 16px;
  cursor: pointer;
  user-select: none;
  -webkit-user-drag: none;
}

.pic-to-pic-content div {
  width: 54px;
  height: 100%;
  margin-left: 5px;
  box-sizing: border-box;
  font-size: 13px;
  color: #b39479;
  line-height: 18px;
  background: #f5fdfc;
  border-radius: 16px;
  border: 1px solid #b39479;
  text-align: center;
  line-height: 29.6px;
  cursor: pointer;
  user-select: none;
}

.upload-content {
  position: absolute;
  top: 44px;
  left: -44px;
  z-index: 1;
  width: 332px;
  height: 235px;
  box-sizing: border-box;
  padding-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}

.upload-content-inner {
  position: absolute;
  top: 21px;
  left: 21px;
  z-index: 9;
  box-sizing: border-box;
  width: 290px;
  height: 189px;
  padding-top: 34px;
  background: #f9f9fc;
  border-radius: 6px;
  pointer-events: none;
}

.upload-content-inner .upload-content-inner-img {
  display: block;
  width: 72px;
  height: 65px;
  margin-left: 110px;
}

.upload-content-inner .upload-content-inner-text {
  margin-top: 14px;
  text-align: center;
}

.upload-content-inner .upload-content-inner-text span:nth-child(1) {
  font-size: 14px;
  font-weight: 600;
  color: #3b3b3b;
  line-height: 20px;
}

.upload-content-inner .upload-content-inner-text span:nth-child(2) {
  font-size: 14px;
  font-weight: 600;
  color: #b39479;
  line-height: 20px;
  text-decoration: underline;
  cursor: pointer;
}

.upload-box {
  width: 292px;
  margin-left: 20px;
}

.upload-box /deep/ .el-loading-parent--relative .el-loading-mask {
  display: none;
}

.user-content {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
}

.app-code-section {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
}
</style>



// WEBPACK FOOTER //
// top-bar-new.vue?42144b58